import { ContentOverlay } from "@chaysehartsuff/active-html";
import { Element } from "@chaysehartsuff/active-html";

/**
 * Aloboi themed modal
 */
export default class AloModal extends ContentOverlay {

    /**
     * The inner styled card that holds modal content.
     * @type {Element}
     */
    card;

    constructor() {
        const card = new Element();
        card.addClass('rounded-3xl border border-emerald-200/20 bg-black/45 p-4 backdrop-blur-sm');

        super(card);

        this.card = card;

        // Prevent clicks inside the card from bubbling up to the overlay and closing it.
        this.card.onEvent('click', (e) => e.stopPropagation());
    }

    addCardContent(content, key = null) {
        this.card.addContent(content, key);
        return this;
    }

    /**
     * Removes content from the inner modal card by key.
     * @param {string|Element} key
     * @returns {this}
     */
    removeContent(key) {
        this.card.removeContent(key);
        return this;
    }

    /**
     * Clears all content from the inner modal card.
     * @returns {this}
     */
    clearContent() {
        this.card.clearContent();
        return this;
    }
}